import { ACTION } from '../stat/stat_actions';

const initialState = {
  stat: {},
  isLoading: false,
  errorMessage: null,
  // Project stats
  projectStats: null,
  projectStatsLoading: false,
  // OTTV
  ottvData: null,
  ottvLoading: false,
  // RTTV
  rttvData: null,
  rttvLoading: false,
  // LPD
  lpdData: null,
  lpdLoading: false,
  // COP
  copData: null,
  copLoading: false,
  // SEER
  seerData: null,
  seerLoading: false,
  // Boiler
  boilerData: null,
  boilerLoading: false,
  // Hot Water COP
  hotWaterCopData: null,
  hotWaterCopLoading: false,
  // PVE (Solar)
  pveData: null,
  pveLoading: false,
  // HEE (Heat to Electrical)
  heeData: null,
  heeLoading: false,
  // Other RE
  otherReData: null,
  otherReLoading: false,
  // Lighting Power
  lightingPowerData: null,
  lightingPowerLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Original stat actions
    case `${ACTION.GET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.GET}_FULFILLED`:
      return {
        ...state,
        stat: action.payload,
        isLoading: false,
      };
    case `${ACTION.GET}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };

    // Project Stats
    case `${ACTION.GET_PROJECT_STATS}_PENDING`:
      return { ...state, projectStatsLoading: true };
    case `${ACTION.GET_PROJECT_STATS}_FULFILLED`:
      return { ...state, projectStats: action.payload, projectStatsLoading: false };
    case `${ACTION.GET_PROJECT_STATS}_REJECTED`:
      return { ...state, projectStatsLoading: false };

    // OTTV
    case `${ACTION.GET_OTTV}_PENDING`:
      return { ...state, ottvLoading: true };
    case `${ACTION.GET_OTTV}_FULFILLED`:
      return { ...state, ottvData: action.payload, ottvLoading: false };
    case `${ACTION.GET_OTTV}_REJECTED`:
      return { ...state, ottvLoading: false };

    // RTTV
    case `${ACTION.GET_RTTV}_PENDING`:
      return { ...state, rttvLoading: true };
    case `${ACTION.GET_RTTV}_FULFILLED`:
      return { ...state, rttvData: action.payload, rttvLoading: false };
    case `${ACTION.GET_RTTV}_REJECTED`:
      return { ...state, rttvLoading: false };

    // LPD
    case `${ACTION.GET_LPD}_PENDING`:
      return { ...state, lpdLoading: true };
    case `${ACTION.GET_LPD}_FULFILLED`:
      return { ...state, lpdData: action.payload, lpdLoading: false };
    case `${ACTION.GET_LPD}_REJECTED`:
      return { ...state, lpdLoading: false };

    // COP
    case `${ACTION.GET_COP}_PENDING`:
      return { ...state, copLoading: true };
    case `${ACTION.GET_COP}_FULFILLED`:
      return { ...state, copData: action.payload, copLoading: false };
    case `${ACTION.GET_COP}_REJECTED`:
      return { ...state, copLoading: false };

    // SEER
    case `${ACTION.GET_SEER}_PENDING`:
      return { ...state, seerLoading: true };
    case `${ACTION.GET_SEER}_FULFILLED`:
      return { ...state, seerData: action.payload, seerLoading: false };
    case `${ACTION.GET_SEER}_REJECTED`:
      return { ...state, seerLoading: false };

    // Boiler
    case `${ACTION.GET_BOILER}_PENDING`:
      return { ...state, boilerLoading: true };
    case `${ACTION.GET_BOILER}_FULFILLED`:
      return { ...state, boilerData: action.payload, boilerLoading: false };
    case `${ACTION.GET_BOILER}_REJECTED`:
      return { ...state, boilerLoading: false };

    // Hot Water COP
    case `${ACTION.GET_HOT_WATER_COP}_PENDING`:
      return { ...state, hotWaterCopLoading: true };
    case `${ACTION.GET_HOT_WATER_COP}_FULFILLED`:
      return { ...state, hotWaterCopData: action.payload, hotWaterCopLoading: false };
    case `${ACTION.GET_HOT_WATER_COP}_REJECTED`:
      return { ...state, hotWaterCopLoading: false };

    // PVE
    case `${ACTION.GET_PVE}_PENDING`:
      return { ...state, pveLoading: true };
    case `${ACTION.GET_PVE}_FULFILLED`:
      return { ...state, pveData: action.payload, pveLoading: false };
    case `${ACTION.GET_PVE}_REJECTED`:
      return { ...state, pveLoading: false };

    // HEE
    case `${ACTION.GET_HEE}_PENDING`:
      return { ...state, heeLoading: true };
    case `${ACTION.GET_HEE}_FULFILLED`:
      return { ...state, heeData: action.payload, heeLoading: false };
    case `${ACTION.GET_HEE}_REJECTED`:
      return { ...state, heeLoading: false };

    // Other RE
    case `${ACTION.GET_OTHER_RE}_PENDING`:
      return { ...state, otherReLoading: true };
    case `${ACTION.GET_OTHER_RE}_FULFILLED`:
      return { ...state, otherReData: action.payload, otherReLoading: false };
    case `${ACTION.GET_OTHER_RE}_REJECTED`:
      return { ...state, otherReLoading: false };

    // Lighting Power
    case `${ACTION.GET_LIGHTING_POWER}_PENDING`:
      return { ...state, lightingPowerLoading: true };
    case `${ACTION.GET_LIGHTING_POWER}_FULFILLED`:
      return { ...state, lightingPowerData: action.payload, lightingPowerLoading: false };
    case `${ACTION.GET_LIGHTING_POWER}_REJECTED`:
      return { ...state, lightingPowerLoading: false };

    // Clear all stats
    case ACTION.CLEAR_ALL_STATS:
      return {
        ...state,
        ottvData: null,
        rttvData: null,
        lpdData: null,
        copData: null,
        seerData: null,
        boilerData: null,
        hotWaterCopData: null,
        pveData: null,
        heeData: null,
        otherReData: null,
        lightingPowerData: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/stat/stat_reducer.js